import type { LandingDemoReplay } from "@/components/marketing/HeroDemoPlayer";
import LandingWalkthroughPlayer from "@/components/marketing/LandingWalkthroughPlayer";

type Props = {
  replay: LandingDemoReplay;
};

export default function SampleEvaluationSection({ replay }: Props) {
  return (
    <section id="sample-evaluation" className="bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            This is what an audit looks like.
          </h2>
          <p className="mt-4 text-lg text-gray-600">Play a short path, then click a finding to see why it matters.</p>
        </div>
        <div className="mt-10">
          <LandingWalkthroughPlayer replay={replay} />
        </div>
      </div>
    </section>
  );
}
